import { render, staticRenderFns } from "./ConversationEmpty.vue?vue&type=template&id=781445b0&"
import script from "./ConversationEmpty.vue?vue&type=script&lang=js&"
export * from "./ConversationEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports